<div (click)="this.main?.linkBlank(this.generateUrl())" [class.cardAgente__borderCard]="this.isDetailBrandPage==true"
    class="cardAgente cursor-pointer">
    <div class="cardAgente__top d-flex cursor-pointer">

        <div class="roundedImage">
            <img [class.roundedImage--agentPlaceholder]="!this.professionistObj?.member?.profile_img"
                [ngSrc]="this.main.generatePictureUrl(this.professionistObj?.member?.profile_img, '80', 'agent')"
                alt="cover card professionista" fill="center" />
        </div>

        <div class="ratingAndName ps-2">
            <div class="nameAndRole">
                <h4 class="p-0 m-0 text-uppercase name textOneLine fw-600">{{this.professionistObj?.member?.first_name}}
                    {{this.professionistObj?.member?.last_name}}</h4>
                <div class="d-flex">
                    <ng-container
                        *ngIf="this.professionistObj?.agency_role==='' || !this.professionistObj?.agency_role; else showAgentRole">
                        <p class="mb-0">{{this.brandObj?.name | titlecase}}</p>
                    </ng-container>
                    <ng-template #showAgentRole>
                        <p class="mb-0 me-1">{{this.professionistObj?.agency_role | titlecase}}, {{this.brandObj?.name |
                            titlecase}}</p>
                    </ng-template>
                </div>
            </div>

            <div class="agentAddress d-flex align-items-baseline">
                <i class="icon-map-marker-alt me-1"></i>
                <p>{{this.professionistObj?.address | titlecase}} <span>- {{this.professionistObj?.city |
                        titlecase}}</span></p>
            </div>

            <div class="d-flex align-items-center justify-content-start mt-1">
                <div class="agentRating d-flex align-items-center">
                    <i [class.starNoReview]="this.professionistObj?.number_reviews == 0" class="icon-star"></i>
                    <p *ngIf="this.professionistObj?.average_stars" class="mb-0 ms-1 fw-normal">
                        {{this.professionistObj?.average_stars | number : '1.1-1'}}</p>
                    <p *ngIf="!this.professionistObj?.average_stars" class="mb-0 ms-1 fw-normal">0</p>
                    <p class="mb-0 ms-1 fw-normal">({{this.professionistObj?.number_reviews}})</p>
                </div>

                <div class="starCont m-0 ms-2" (click)="$event.stopPropagation(); this.handleFavouriteProfessionist()">
                    <i class="me-1" [class.icon-heart]="this.main?.savedProfessionist(this.professionistObj?.id)"
                        [class.icon-heart-saved]="!this.main?.savedProfessionist(this.professionistObj?.id)"></i>
                    {{this.professionistObj?.numberOfFavourites}}
                </div>

                <div class="starCont starCont--likes m-0 ms-2"
                    (click)="$event.stopPropagation(); this.handleLikesProfessionist()">
                    <i class="me-1"
                        [class.colorPrimary]="!this.main?.checkLikedProfessionist(this.professionistObj?.id)"
                        [class.icon-thumbs-up]="this.main?.checkLikedProfessionist(this.professionistObj?.id)"
                        [class.icon-thumbs-up-liked]="!this.main?.checkLikedProfessionist(this.professionistObj?.id)"></i>
                    {{this.professionistObj?.likes}}
                </div>
            </div>

        </div>
    </div>
    <div class="cardAgente__middle">
        <div class="cardAgente__middle__agentData">
            <div class="cardAgente__middle__agentData__item">
                <p class="mb-0 fw-600 orangeColor">{{this.showProductFilter(1)?.length}}</p>
                <p class="mb-0 fw-600">Finanziario</p>
            </div>
            <div class="cardAgente__middle__agentData__item">
                <p class="mb-0 fw-600 greenColor">{{this.showProductFilter(2)?.length}}</p>
                <p class="mb-0 fw-600">Assicurativo</p>
            </div>
        </div>
        <div class="cardAgente__middle__agentZones d-flex mt-2">
            <ng-container *ngIf="this.professionistObj?.zones_served?.length > 0">
                <div class="d-flex zoneServedCont">
                    <ng-container *ngFor="let zone of this.professionistObj?.zones_served; let i=index">
                        <ng-container *ngIf="i<2">
                            <div class="singleZone d-flex me-2 align-items-center justify-content-center">
                                <i class="icon-map-marker-alt me-1"></i>
                                <p class="mb-0">{{zone.display_name}}</p>
                            </div>
                        </ng-container>
                    </ng-container>
                    <div *ngIf="this.professionistObj?.zones_served.length > 2"
                        class="singleZone d-flex me-1 align-items-center justify-content-center px-2">
                        <p class="mb-0">+{{this.professionistObj?.zones_served.length-2}}</p>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
    <!-- <div class="cardAgente__namingList d-flex align-items-center">
        <ng-container *ngIf="this.countAgentSkills()">
            <div class="specContainer">
                {{this.orderAgentSkills().skills.join(' - ')}}
            </div>
        </ng-container>
    </div> -->

    <div class="cardAgente__namingList d-flex">
        <ng-container *ngIf="this.professionistObj?.specialization?.length > 0">
            <div class="specContainer">
                {{this.professionistObj?.specialization?.join(', ')}}
            </div>
        </ng-container>
    </div>

    <div class="cardAgente__logosRow d-flex pb-0 pt-1">
        <div class="whuisCertificato-wrapper">
            <ng-container *ngIf="this.professionistObj?.verified==='whuis'">
                <div class="logoWhuis me-3"></div>
            </ng-container>
        </div>

        <div class="logoAgenzia position-relative">
            <img [ngSrc]="'assets/img/auxilia_logo.png'" fill="center" alt="Logo agenzia">
        </div>
    </div>
</div>